import { useState, useEffect } from "react";
import { X, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotificationBanner = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Check for new articles notification (simulated)
    const lastCheck = localStorage.getItem("lastArticleCheck");
    const now = Date.now();
    
    if (!lastCheck || now - parseInt(lastCheck) > 3600000) { // 1 hour
      setMessage("New articles available! Load more to see the latest content.");
      setShow(true);
      localStorage.setItem("lastArticleCheck", now.toString());
    }
  }, []);

  const handleDismiss = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 bg-blue-600 text-white px-6 py-4 rounded-lg shadow-2xl max-w-md animate-in slide-in-from-bottom"
      data-testid="notification-banner"
    >
      <div className="flex items-start gap-3">
        <Bell className="w-5 h-5 mt-0.5 shrink-0" />
        <div className="flex-1">
          <p className="font-medium mb-1">Notification</p>
          <p className="text-sm text-blue-100">{message}</p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-blue-700 shrink-0"
          onClick={handleDismiss}
          data-testid="dismiss-notification"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default NotificationBanner;
